import React, { useEffect, useMemo } from 'react'
import withAuthentication from '../../containers/Authentication/withAuthentication';
import { withTranslation } from 'react-i18next';
import Remove from '@material-ui/icons/Delete'
import Edit from '@material-ui/icons/Edit'
import { Tooltip,Typography } from '@material-ui/core'
import Button from '../../components/CustomButtons/Button'
import tableStyle from '../../shared/styles/tableSortIcon.css'
import ReactTable from 'react-table'
import addReactTableFilterPlaceholder from '../../shared/react-table/addReactTableFilterPlaceholder.js'
import {
    NAME,
    DESCRIPTION,
    EDIT,
    REMOVE
  } from './constants.js'

//-----------------------Variable for No. of Page--------------------------//
const DEFAULT_PAGE_SIZE = 10

// -----------------------Function for Creating TableData--------------------------//
function convertToTableData(
    groups,
    // openUpdateGroupModal,
    // openDeleteGroupModal,
    t
  ) {
    return groups.map(group => {
      return {
        [NAME]: group.name,
        [DESCRIPTION]: group.description,
        [EDIT]: (
            <div className='actions-left'>
                <Button
                justIcon
                round
                simple
                // onClick={() => {
                //   openUpdateGroupModal(group)
                // }}
                id='usersEditButton'
                className='edit'
              >
                <Tooltip title={t('Edit')}>
                  <Edit style={{ color: '#3c4858', height: '18px', cursor: 'pointer' }} />
                </Tooltip>
              </Button>
            </div>
        ),
        [REMOVE]: (
            <div className='actions-left'>
                <Button
                justIcon
                round
                simple
                // onClick={() => {
                //   openDeleteGroupModal(group)
                // }}
                id='usersDeleteButton'
              >
                <Tooltip title={t('Delete')}>
                  <Remove style={{ color: '#3c4858', height: '18px', cursor: 'pointer' }} />
                </Tooltip>
              </Button>
            </div>
        ),
      }
    })
  }

//------------------------Render whole Table-------------------------//
const Groups = ({groups,t}) => {
  // ---------------------For Set Placeholder In Search Input----------------------------//
    useEffect(() => {
        addReactTableFilterPlaceholder()
      }, [])
    
      const tableData = useMemo(() => convertToTableData(
        groups,
        // openUpdateGroupModal,
        // openDeleteGroupModal,
        t
      ), [groups]) // eslint-disable-line react-hooks/exhaustive-deps
        
  return (
    <ReactTable
        data={tableData}
        filterable
        style={tableStyle}
        NoDataComponent={() => null}
        columns={[
          {
            Header: () => null,
            Cell: (row) => {
              return <div>{(row.viewIndex + 1) + row.page * row.pageSize}</div>
            },
            sortable: false,
            filterable: false,
            width: 50
          },
          {
            Header: () => (
              <div
                style={{
                  textAlign: 'left'
                }}
              >
                <Typography variant='body2'>{t('Name')}</Typography>
              </div>
            ),
            accessor: NAME,
            sortable: true,
            filterable: true

          },
          {
            Header: () => (
              <div
                style={{
                  textAlign: 'left'
                }}
              >
                <Typography variant='body2'>{t('Description')}</Typography>
              </div>
            ),
            accessor: DESCRIPTION,
            sortable: true,
            filterable: true
          },
          {
            Header: () => (
              <div
                style={{
                  textAlign: 'left'
                }}
              >
                <Typography variant='body2'>{t('Edit')}</Typography>
              </div>
            ),
            accessor: EDIT,
            style: { textAlign: 'left' },
            sortable: false,
            filterable: false
          },
          {
            Header: () => (
              <div
                style={{
                  textAlign: 'left'
                }}
              >
                <Typography variant='body2'>{t('Delete')}</Typography>
              </div>
            ),
            accessor: REMOVE,
            style: { textAlign: 'left' },
            sortable:false,
            filterable: false,
          }
        ]}
        defaultPageSize={DEFAULT_PAGE_SIZE}
        nextText={t('Next')}
        pageText={t('Page')}
        ofText={t('Of')}
        onPageChange={() => {
          document.getElementById('mainPanel').scrollTop = 0
        }}
        rowsText={t('Rows')}
        previousText={t('Previous')}
        minRows={0}
        showPaginationBottom={
          tableData.length > DEFAULT_PAGE_SIZE
        }
        className='-striped -highlight'
      />
  )
}

export default withAuthentication(withTranslation()(Groups))
